module.exports = __webpack_public_path__ + "img/arrow.0390dea3.svg";